import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_HR: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologija',
  components_header_media_multi_content_2: 'Meditacija',
  components_header_media_multi_content_3: 'Ljubav',
  components_header_text1: 'Vodiči',
  components_header_text2: 'Blog',
  hero_text: 'Pronađite jasnoću, ravnotežu i povezanost.',
  hero_button_text: 'Započnite svoje putovanje',
  components_ressources_subheader_text: 'Savjeti i inspiracija',
  components_ressources_span_text: 'Objedinjuje osobne astrološke uvide, smirujuće meditacijske prakse i promišljeno ljubavno vodstvo kako bi podržao samospoznaju, emocionalnu ravnotežu i dublju povezanost.',
  components_ressources_card_1_title: 'Savjeti za meditaciju',
  components_ressources_card_1_text: 'Kratki vodič za bolje smirivanje, disanje i koncentraciju.',
  components_ressources_card_2_title: 'Ljubavno vodstvo',
  components_ressources_card_2_text: 'Jednostavni savjeti za izgradnju jače veze i emocionalne ravnoteže.',
  components_ressources_link: 'Otkrijte više',
  components_notes_and_google_title_1: 'Pronađite jasnoću',
  components_notes_and_google_title_2: 'Unutarnji mir',
  components_notes_and_google_title_3: 'Veza sa srcem',
  media_content_section_multi_1_subheader_text: 'Naš podcast',
  media_content_section_multi_2_subheader_text: 'Naše meditacije',
  media_content_section_multi_3_subheader_text: 'Pravi razgovor o kozmičkoj romansi',
  page_media_content_menu_antistress: 'Antistres',
  page_media_content_menu_mindfulness: 'Svjesnost',
  page_media_content_menu_energyboost: 'Poticaj energije',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Temelji',
  page_media_content_menu_spirituality: 'Duhovnost',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psihologija',
  page_media_content_menu_trends: 'Trendovi',
  page_media_content_menu_compatibility: 'Kompatibilnost',
  page_media_content_menu_love: 'Ljubav',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članci i uvidi',
  text2_section_button_more: 'Učitaj više',
  components_text1_section_title: 'VODIČI',
  components_text1_subheader_text: 'Kozmičko znanje za svakodnevno usklađivanje',
  components_text1_span_text: 'Uskladite se s ritmovima svemira: istražite odabranu kolekciju detaljnih astroloških i meditativnih vodiča osmišljenih za buđenje unutarnje jasnoće, produbljivanje samosvijesti i podršku vašem putovanju duhovnog, nebeskog rasta.',
  components_text1_card_1_title: 'Otvori se prema tišini',
  components_text1_card_1_text: 'Započnite svoje putovanje s temeljnim vodičima za meditaciju i astrologiju - idealnim za tražitelje privučene unutarnjom tišinom, kozmičkim obrascima i osobnim uvidima.',
  components_text1_card_3_title: 'Veza uma i tijela',
  components_text1_card_3_text: 'Otkrijte dublje slojeve svog unutarnjeg svijeta. Ovi vodiči kreću se ispod površine kako bi otkrili značenje, emocije i obrasce svjesnosti koji oblikuju vaše iskustvo.',
  components_text1_card_2_title: 'Razmisli i integriraj',
  components_text1_card_2_text: 'Od emocionalnih blokada do planetarnih ciklusa - ovi vodiči nude alate za promišljanje, iscjeljenje i transformaciju kroz svjesne rituale i astrološku mudrost.',
  components_text1_link: 'Prikaži sve vodiče',
  components_footer_text: 'Pronađite jasnoću, uravnotežite svoj um i povežite se sa smislom – vaše mjesto za astrologiju, meditaciju i ljubav.',
};